/** 代码块：语言切换与复制按钮。「已复制」复用 common.copied。 */
const messages = {
  tabs: '代码示例语言',
  copy: '复制',
  copyCode: '复制代码',
  copiedLive: '代码已复制',
};

export default messages;
